import { render } from "./CustomerAppData.vue?vue&type=template&id=16b5c3fa&ts=true"
import script from "./CustomerAppData.vue?vue&type=script&lang=ts"
export * from "./CustomerAppData.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__